import React from 'react';
import './Header.scss';
import { ReactComponent as CrystoIcon } from 'assets/icons/Crysto.svg';
import { ReactComponent as FrogIcon } from 'assets/icons/FrogIcon.svg';
import { Link } from 'react-router-dom';
import { useAppSelector } from 'store/store';
import { MenuOutlined } from '@ant-design/icons';
import { Dropdown, Menu } from 'antd';
import { IUser } from 'store/reducers/users/types';

function NavigationMenu({ user }: { user: IUser }): React.ReactElement {
    const items = [
        {
            key: 1,
            label: <Link to="/">Главная</Link>,
        },
        {
            key: 2,
            label: <Link to="/history">История</Link>,
        },
        {
            key: 3,
            label: <Link to="/rating">Рейтинг</Link>,
        },
    ];
    if (user?.is_superuser) {
        items.push({
            key: 4,
            label: <Link to="/admin">Начисление</Link>,
        });
    }
    return <Menu items={items} />;
}

function DropdownNavigation({ user }: { user: IUser }): React.ReactElement {
    return (
        <Dropdown trigger={['click']} overlay={<NavigationMenu user={user} />}>
            <MenuOutlined />
        </Dropdown>
    );
}

function Header(): React.ReactElement {
    const { user } = useAppSelector(state => state.usersStore);

    return (
        <header>
            {!!user && <DropdownNavigation user={user} />}
            <Link to="/">
                <CrystoIcon className="crysto-logo" />
            </Link>
            <nav>
                <Link to="/">Главная</Link>
                <Link to="/history">История</Link>
                <Link to="/rating">Рейтинг</Link>
                {user?.is_superuser && <Link to="/admin">Начисление</Link>}
            </nav>
            <div className="profile">
                <span className="profile_name">{user?.first_name}</span>
                <div className="frogs-counter">
                    {user?.frogs} <FrogIcon />
                </div>
            </div>
        </header>
    );
}

export default React.memo(Header);
